import { SxProps } from '@mui/material/styles';

export const styles = {
  tableDataContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
} satisfies Record<string, SxProps>;
